import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const socialLinksUrls = [
    {
        href: "https://www.facebook.com/Atlassian",
        title: "Atlassian on Facebook",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/facebook-badge.svg"
    },
    {
        href: "https://twitter.com/atlassian",
        title: "Follow us on Twitter",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/twitter.svg"
    },
    {
        href: "https://www.linkedin.com/company/atlassian",
        title: "Atlassian on LinkedIn",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/linked-in.svg"
    },
    {
        href: "https://www.youtube.com/user/GoAtlassian",
        title: "Atlassian on YouTube",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/youtube-round-gray-adg.svg"
    }
];

const socialLinksUlStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "unset",

    [media.below.sm]: {
        gap: "13px"
    },
    [media.above.sm]: {
        gap: "5px"
    }
});

const socialLinksLiStyle = css({
    listStyleType: "none",

    [media.below.md]: {
        height: token("space.300"),
        width: token("space.300")
    },
    [media.above.md]: {
        height: token("space.400"),
        width: token("space.400")
    }
});

const socialAnchorStaticStyle = css({
    color: "#42526e",
    fontSize: "0.875rem",
    lineHeight: "1.125",
    textDecoration: "none",
    display: "block",
    textIndent: "-99999px",
    width: "100%",
    height: "100%"
});

const socialAnchorDynamicStyle = (socialLinksUrlImage: string) => {
    return {
        background: `url(${socialLinksUrlImage}) no-repeat scroll center center`,
        backgroundSize: "100%"
    };
};

export interface SocialLinksProps {
    className?: string;
}

export const SocialLinks = ({ className }: SocialLinksProps) => {
    return (
        <div className={className} css={css({ display: "inline-flex" })}>
            <ul css={socialLinksUlStyle}>
                {socialLinksUrls.map((socialLinkUrl) => (
                    <li css={socialLinksLiStyle} key={socialLinkUrl.title}>
                        <a
                            css={socialAnchorStaticStyle}
                            style={socialAnchorDynamicStyle(
                                socialLinkUrl.socialImagePath
                            )}
                            href={socialLinkUrl.href}
                            title={socialLinkUrl.title}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
